import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Paths, templatesPath } from 'routes';
import Collection from 'types/Collection';

const initialContext = {
  collection: null,
  setCollection: () => undefined,
};

export const UseCollectionContext = React.createContext<{
  collection: Collection | null;
  setCollection: (collection: Collection | null, redirect: boolean) => void;
}>(initialContext);

export const useCollection = (): {
  collection: Collection | null;
  setCollection: (collection: Collection | null, redirect: boolean) => void;
} => useContext(UseCollectionContext);

export const UseCollectionProvider = ({ children }: { children: React.ReactNode }) => {
  const [collection, setCollection] = useState<Collection | null>(initialContext.collection);
  const navigate = useNavigate();

  const onHandleSetCollection = (collection: Collection | null, redirect: boolean) => {
    const goTo = collection ? templatesPath(collection.id) : Paths.root;

    setCollection(collection);

    if (redirect) {
      navigate(goTo);
    }
  };

  return (
    <UseCollectionContext.Provider
      value={{
        collection,
        setCollection: onHandleSetCollection,
      }}
    >
      {children}
    </UseCollectionContext.Provider>
  );
};
